export default {
  init() {
    if ($('.content').length) {
      var postLinks = $('.content__links');

      $('.anchor-block').each(function () {
        var block = $(this);
        var title = block.data('heading');
        var blockid = block.data('id');
        var link = $('<a/>', {
          'href': '/',
          'class': 'link-icon link-icon--arrow-right',
          'data-block-id': blockid,
          'text': title,
        });

        $('<li/>').append(link).appendTo($('ul', postLinks));
      });

      postLinks.on('click', 'a', function (e) {
        e.preventDefault();

        var blockId = $(this).data('block-id');
        console.log($('[data-id="' + blockId + '"]').offset().top );
        $('html, body').animate({scrollTop: $('[data-id="' + blockId + '"]').offset().top }, 600);
      });
    }
  },
};
